import { memo } from 'react';
import { X, Download } from 'lucide-react';
import { HeaderAudioIcon } from '@/components/HeaderAudioIcon';
import { FileFavoritesDropdown } from './FileFavoritesDropdown';
import type { FavoriteItem } from '@/types/favorites';

interface ViewerHeaderProps {
  title?: string;
  subtitle?: string;
  onClose: () => void;
  onDownload?: () => void;
  onOpenFavorite?: (favorite: FavoriteItem) => void;
}

function ViewerHeaderInner({
  title,
  subtitle,
  onClose,
  onDownload,
  onOpenFavorite,
}: ViewerHeaderProps) {
  return (
    <header className="bg-[#63345e] text-white px-3 sm:px-4 py-2.5 flex items-center justify-between shrink-0 safe-area-top">
      <button
        onClick={onClose}
        className="p-2 hover:bg-[#8e4585] rounded-lg transition-colors"
        aria-label="Close viewer"
      >
        <X size={22} />
      </button>

      <div className="flex-1 text-center mx-3 min-w-0">
        <h1 className="font-semibold text-sm sm:text-base truncate">{title || 'Viewer'}</h1>
        {subtitle && <p className="text-[#f0d2f0] text-[10px] sm:text-xs truncate">{subtitle}</p>}
      </div>

      <div className="flex items-center gap-0.5">
        <HeaderAudioIcon />

        <FileFavoritesDropdown onOpenFile={onOpenFavorite} />

        {onDownload && (
          <button
            onClick={onDownload}
            className="p-2 hover:bg-[#8e4585] rounded-lg transition-colors"
            aria-label="Download"
          >
            <Download size={20} />
          </button>
        )}
      </div>
    </header>
  );
}

export const ViewerHeader = memo(ViewerHeaderInner);
